// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4bb8028","239":"eab0352a","455":"cea02515"}[chunkId] + ".chunk.js";
};